<template>
  <div class="mb-3">
    <MainSelect />
    <Connection v-for="connection in locationsConnections" :connection="connection" :key="connection.remoteId" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import MainSelect from './main_select'
import Connection from './connection'

export default {
  computed: {
    ...mapState(['locationsConnections'])
  },
  components: { MainSelect, Connection }
}
</script>
